import { render } from "./FuncionPage.vue?vue&type=template&id=e97c866a&scoped=true"
import script from "./FuncionPage.vue?vue&type=script&lang=js"
export * from "./FuncionPage.vue?vue&type=script&lang=js"

import "./FuncionPage.vue?vue&type=style&index=0&id=e97c866a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e97c866a"]])

export default __exports__